// All brands require Arabic to be displayed as Latin characters
/**
 * This approach uses the Unicode BCP47 Extensions
 * TLDR;
 * add -u-nu-latn to a locale to pass to Intl.NumberFormat to
 * allow for arabic text currency code and latin numerals
 *
 * For further details about this unicde formatting please see:
 * - https://www.unicode.org/reports/tr35/tr35.html#BCP_47_Conformance
 * - https://www.w3.org/International/multilingualweb/dublin/slides/23b-davis.pdf
 * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
 *
 * - links to the above and a local copy of the PDF can be found on confluence at https://confluence.nap/display/TON/TON+Arabic+Pricing
 */
export const sanitiseLocale = locale => (typeof locale === 'string' && locale.slice(0, 2) === 'ar' ? `${locale}-u-nu-latn` : locale);
